/**
 * 郵便番号住所自動表示
 */
$(function () {
    const $zipcode = $("#zipcode");
    const $hiddenPrefName = $(".p-region");
    const $prefIdSelect = $("#prefecture_id");
    const $address = $("#address");
    const $building = $("#building");

    $zipcode.on("keyup", function () {

        if ($hiddenPrefName.val().length > 0) {
            $("option",$prefIdSelect).each(function () {
                const label = $.trim($(this).text());
                if ($hiddenPrefName.val() === label) {
                    // 検索結果の都道府県と一致する都道府県を選択
                    $prefIdSelect.val($(this).val());
                }
            });
        }else{
            // 郵便番号入力中は他の住所項目初期化
            $prefIdSelect.val("0");
            $address.val("");
            $building.val("");
        }
    });
});

/**
 * かな入力補助
 */
$(function () {
    const name01 = "#family_name";
    const name02 = "#first_name";
    const kana01 = "#family_name_kana";
    const kana02 = "#first_name_kana";

    $.fn.autoKana(name01, kana01, {katakana: true});
    $.fn.autoKana(name02, kana02, {katakana: true});
});


/**
 * 銀行・支店オートコンプリート表示
 */
$(function () {

    const $bank = $("#bank");
    const $branch = $("#branch");

    // Todo:この方法だとデータソースが更新されないので検索方法を確認
    $.getJSON(register.bank_json_path + "/banks.json", function (data) {
        var banks = hashSearchBanks(data);
        var opts = {
            source: banks,
            autoFocus: true,
            select: function (event, ui) {

                $.getJSON(register.bank_json_path + "/branches/" + ui.item.code + ".json", function (data) {
                    var branches = hashSearchBranch(data);
                    var child_opts = {
                        source: branches,
                        autoFocus: true
                    };
                    $branch.autocomplete(child_opts).autocomplete('option', 'minLength', 0);
                    $branch.val("");
                });

            }
        };
        $bank.autocomplete(opts).autocomplete('option', 'minLength', 1);
    });


    // 銀行リスト
    function hashSearchBanks(data) {
        var banks = [];
        $.each(data, function (index, element) {
            var bank = {
                value: element.name + "銀行",
                label: element.code + " : " + element.name + "銀行 (" + element.kana + ")",
                code: element.code,
                name: element.name
            };
            banks.push(bank);
        });
        return banks;
    }

    // 支店リスト
    function hashSearchBranch(data) {
        var banks = [];
        $.each(data, function (index, element) {
            var bank = {
                value: element.name + "支店",
                label: element.code + " : " + element.name + "支店 (" + element.kana + ")",
                code: element.code,
                name: element.name
            };
            banks.push(bank);
        });
        return banks;
    }

});

window.submit_form = (function () {
    var sent = false;

    return function () {
        if (sent) {
            return false;
        }
        sent = window.confirm('本当に変更してよろしいですか？');

        return sent;
    };
})();
